

import React from 'react';

import './style.css'

import successIcon from '../../assets/success-icon.png';

interface IModalProps {
    isOpen: boolean,
    onClose: () => void,
    onClose2: () => void
}

const SuccessModal: React.FC<IModalProps> = ({ isOpen = false, onClose, onClose2  }) => {


    if (!isOpen) {
        return null;
      }
    
      return (
        <div className="modal-overlay">
          <div className="modal-content">
            <div className='center-middle'>
                <div className="icon-size-2">
                    <img className="responsive-image" src={successIcon} />
                </div>
            </div>
            <br />
            <div className='center-middle font-size-17px'>
                Registration Complete
            </div>
            <div className='center-middle  font-size-17px'>
             Do you want to stay or login the account?
             </div>
            <br />
            <div className="center-middle">
                <button type="button" className='btn-white-green-2 center-middle' onClick={onClose} >Stay</button>
                &nbsp;  &nbsp;
                <button type="button" className='btn-green-2 center-middle' onClick={onClose2} >Login</button>
            </div>
          </div>
        </div>
      );

}

export default SuccessModal;